import React from "react";
import apiRequest from "utils/ApiRequest/apiRequest";
import Icon from "components/Elements/Icon/Icon";
import Form from "components/Reusable/Form/Form";
import { useContent } from "../../../contexts/contentContext/contentContext";

import styles from "./styles.module.scss";

const UserAuthentication = () => {
  const { getLanguage } = useContent();
  const handleSubmit = async (body: { login: string; password: string }) => {
    const res = await apiRequest("Users", "AuthenticateUser", body);
    if (res.status === "success") {
      window.location.href = `/${getLanguage() || "en"}/home`;
      return res;
    }
  };

  return (
    <div className={styles.container}>
      <Icon name="mobile-icon-jumbomail" iconClass={styles.jmIcon} />
      <h1>Welcome to Test Environment!</h1>
      <Form
        onSubmit={handleSubmit}
        submitProps={{ title: "Login", className: styles.submitButton }}
        fieldsProps={{ field: styles.field, label: styles.label }}
        fields={{
          login: {
            fieldKey: "login",
            element: "input",
            title: "UserName",
            placeholder: "login",
            label: "User name",
            validation: {
              required: true,
            },
          },
          password: {
            fieldKey: "password",
            element: "input",
            type: "password",
            title: "Password",
            placeholder: "password",
            label: "Password",
            hidePassStrength: true,
          },
        }}
      />
    </div>
  );
};

export default UserAuthentication;
